<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户名">
          <el-input v-model="formInline.nickName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
      <el-table-column prop="userName" label="用户名" width="180">
      </el-table-column>
      </el-table-column>
      <el-table-column prop="changeTypeName" label="调整等级类型">
      </el-table-column>
      <el-table-column prop="oldGradeName" label="旧等级">
      </el-table-column>
      <el-table-column prop="newGradName" label="新等级">
      </el-table-column>
      <el-table-column prop="dateTypeName" label="时效">
      </el-table-column>
      <el-table-column prop="operatorUser" label="操作人">
      </el-table-column>
      <el-table-column prop="createTime" label="操作时间">
      </el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
        :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>

</template>

<script>
  import UserApi from '@/api/user.js';
  import qs from "qs";
  import {getCookie} from '@/utils/base.js';
  export default {
    data() {
      return {
        formInline: {},
        tableData: [],
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
      }
    },
    methods: {
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        self.loading = true;
        UserApi.gradeLogList(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.records;
            self.totalDataNumber = res.data.total;
          })
          .catch(error => {
            self.loading = false;
          });

      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },
      onExport: function() {
        let self = this;
        let Params = self.formInline;
        Params.token = getCookie('token');
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/api/shop/UserAgent/UserAgent/exportChangeChildLevelLog?' + qs.stringify(Params);
      }

    },

    created() {
      /*获取列表*/
      this.getTableList();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/gradelog/index.vue